import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TitleIcon from './assets/titleIcon.svg';

import './styles/testimonialCard.scss';

export default class TestimonialCard extends Component {

  render() {
    const { clientName, clientTitle, testimonialText, thumbnailImage } = this.props.info;
    const img = (thumbnailImage ? thumbnailImage.fields.file.url : null);
    return (
      <div className="testimonial-card">
        <img src={TitleIcon} alt="" height="28" width="41" />
        <div className="testimonial-card__text">{testimonialText}</div>
        { img &&
          <img src={img}
            height="120"
            width="120"
            className="testimonial-card__img" />
        }
        <div className="testimonial-card__divider" />
        <h3 className="testimonial-card__name">{clientName}</h3>
        <h3 className="testimonial-card__title">{clientTitle}</h3>
      </div>
    );
  }
}

TestimonialCard.propTypes = {
  info: PropTypes.object
};
